import { RAFFLE_IMAGE_URL } from '../parameters';
import RouteHelper from '../helpers/RouteHelper';
import MutationService from './MutationService';

export default class RaffleService {

	/**
	 * @param {string} image
	 * @return {string}
	 */
	static getImageUrl(image) {
		if (image === null) {
			return '/assets/images/default-raffle-image.jpeg';
		}
		return RAFFLE_IMAGE_URL + '/' + image;
	}

	/**
	 * @param {Raffle} raffle
	 * @return {string}
	 */
	static getDetailUrl(raffle) {
		const slug = raffle.getSlug(MutationService.getMutationCode());
		return RouteHelper.getUrl(`/${slug}-${raffle.id}`);
	}
}


// WEBPACK FOOTER //
// ./services/RaffleService.js